<template>
  <div class="container">
    <h1 class="py-4">トランサクションデータ</h1>
    <div v-if="show" :key="key">
      <div v-if="loading">loading...</div>
      <div v-if="!loading" class="table-responsive">
        <h3>承認売上</h3>
        <div class="mb50">
          <div class="d-flex flex-wrap">
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">取引日</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ data.transaction_date }}</p>
              </div>
            </div>
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">フォーマット区分</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ data.format_category_text }}</p>
              </div>
            </div>
          </div>
          <div class="d-flex flex-wrap">
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">売上•入金区分</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ data.sales_payment_category }}</p>
              </div>
            </div>
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">摘要区分</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ data.summary_category_text }}</p>
              </div>
            </div>
          </div>
          <div class="d-flex flex-wrap">
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">通貨コード</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ data.currency_code }}</p>
              </div>
            </div>
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">カード種類</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ data.card_type }}</p>
              </div>
            </div>
          </div>
          <div class="d-flex flex-wrap">
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">決済買上/入出金金額</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ data.settlement_operation_amount }}</p>
              </div>
            </div>
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">決済ATM手数料</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ data.settlement_atm_fee_amount }}</p>
              </div>
            </div>
          </div>
        </div>
        <h3>取引詳細</h3>
        <div class="mb50">
          <div class="d-flex flex-wrap">
            <div class="d-flex datacontainerFullWidth flex-nowrap">
              <div class="grey-background greyBorder container25 d-flex">
                <p class="ml05">承認売上詳細ID</p>
              </div>
              <div class="greyBorder container75 d-flex">
                <p class="mr05">{{ data.approved_sales_details_id }}</p>
              </div>
            </div>
          </div>
          <div class="d-flex flex-wrap">
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">取引特定情報</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ data.transaction_specific_information }}</p>
              </div>
            </div>
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">元取引特定情報</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">
                  {{ data.original_transaction_specific_information }}
                </p>
              </div>
            </div>
          </div>
          <div class="d-flex flex-wrap">
            <div class="d-flex datacontainerFullWidth flex-nowrap">
              <div class="grey-background greyBorder container25 d-flex">
                <p class="ml05">当初取引特定情報</p>
              </div>
              <div class="greyBorder container75 d-flex">
                <p class="mr05">
                  {{ data.initial_transaction_specific_information }}
                </p>
              </div>
            </div>
          </div>
          <div class="d-flex flex-wrap">
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">契約番号</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ data.contract_number }}</p>
              </div>
            </div>
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">取引日</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ data.transaction_details_date }}</p>
              </div>
            </div>
          </div>
          <div class="d-flex flex-wrap">
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">摘要区分</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ data.summary_details_category }}</p>
              </div>
            </div>
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">残高調整情報ID</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ data.balance_adjustment_information_id }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="mb50">
          <div class="d-flex flex-wrap">
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">カード種類</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ data.card_type }}</p>
              </div>
            </div>
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">買上日</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ data.purchase_date }}</p>
              </div>
            </div>
          </div>
          <div class="d-flex flex-wrap">
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">売上区分</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ data.sales_details_category }}</p>
              </div>
            </div>
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">トランザクションID</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ data.transaction_id }}</p>
              </div>
            </div>
          </div>
          <div class="d-flex flex-wrap">
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">業務区分</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ data.business_category_code }}</p>
              </div>
            </div>
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">承認番号</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ data.approval_number }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="mb50">
          <div class="d-flex flex-wrap">
            <div class="d-flex datacontainerFullWidth flex-nowrap">
              <div class="grey-background greyBorder container25 d-flex">
                <p class="ml05">基準通貨コード</p>
              </div>
              <div class="greyBorder container75 d-flex">
                <p class="mr05">{{ data.base_currency_code }}</p>
              </div>
            </div>
          </div>
          <div class="d-flex flex-wrap">
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">基準買上金額</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ data.base_purchase_amount }}</p>
              </div>
            </div>
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">基準現地手数料</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ data.base_local_fee }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="mb50">
          <div class="d-flex flex-wrap">
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">決済通貨コード</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ data.settlement_currency_code }}</p>
              </div>
            </div>
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">決済買上金額</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">
                  {{ data.settlement_purchase_amount }}
                </p>
              </div>
            </div>
          </div>
          <div class="d-flex flex-wrap">
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">決済ATM手数料</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ data.settlement_atm_fee_details }}</p>
              </div>
            </div>
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">決済海外取扱手数料</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ data.settlement_overseas_handling_fee }}</p>
              </div>
            </div>
          </div>
          <div class="d-flex flex-wrap">
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">ブランド通貨レート</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ data.brand_currency_rate }}</p>
              </div>
            </div>
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">円貨換算レート</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ data.yen_conversion_rate }}</p>
              </div>
            </div>
          </div>
          <div class="d-flex flex-wrap">
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">円貨換算ﾚｰﾄ適用日</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">
                  {{ data.yen_conversion_rate_application_date }}
                </p>
              </div>
            </div>
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">円換算後買上金額</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ data.purchased_amount_after_conversion }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="mb50">
          <div class="d-flex flex-wrap">
            <div class="d-flex datacontainerFullWidth flex-nowrap">
              <div class="grey-background greyBorder container25 d-flex">
                <p class="ml05">更新前残高</p>
              </div>
              <div class="greyBorder container75 d-flex">
                <p class="mr05">{{ data.before_update_balance }}</p>
              </div>
            </div>
          </div>
          <div class="d-flex flex-wrap">
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">更新前円貨利用累計額（1日）</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">
                  {{ data.before_update_cumulative_amount_yen_usage_day }}
                </p>
              </div>
            </div>
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">更新前円貨利用累計額（1ヶ月）</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">
                  {{ data.before_update_cumulative_amount_yen_usage_month }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="mb50">
          <div class="d-flex flex-wrap">
            <div class="d-flex datacontainerFullWidth flex-nowrap">
              <div class="grey-background greyBorder container25 d-flex">
                <p class="ml05">利用通貨コード</p>
              </div>
              <div class="greyBorder container75 d-flex">
                <p class="mr05">{{ data.used_currency_code }}</p>
              </div>
            </div>
          </div>
          <div class="d-flex flex-wrap">
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">利用買上金額</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ data.purchase_amount }}</p>
              </div>
            </div>
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">利用現地手数料</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ data.local_fee }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="mb50">
          <div class="d-flex flex-wrap">
            <div class="d-flex datacontainerFullWidth flex-nowrap">
              <div class="grey-background greyBorder container25 d-flex">
                <p class="ml05">国コード</p>
              </div>
              <div class="greyBorder container75 d-flex">
                <p class="mr05">{{ data.country_code }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="mb50">
          <div class="d-flex flex-wrap">
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">加盟店業種コード</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ data.merchant_category_code }}</p>
              </div>
            </div>
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">加盟店契約業者コード</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ data.merchant_contractor_code }}</p>
              </div>
            </div>
          </div>
          <div class="d-flex flex-wrap">
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">加盟店ID</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ data.merchant_id }}</p>
              </div>
            </div>
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">加盟店端末ID</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ data.merchant_terminal_id }}</p>
              </div>
            </div>
          </div>
          <div class="d-flex flex-wrap">
            <div class="d-flex datacontainerFullWidth flex-nowrap">
              <div class="grey-background greyBorder container25 d-flex">
                <p class="ml05">加盟店名</p>
              </div>
              <div class="greyBorder container75 d-flex">
                <p class="mr05">{{ data.merchant_name }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="mb50">
          <div class="d-flex flex-wrap">
            <div class="d-flex datacontainerFullWidth flex-nowrap">
              <div class="grey-background greyBorder container25 d-flex">
                <p class="ml05">加盟店伝票番号</p>
              </div>
              <div class="greyBorder container75 d-flex">
                <p class="mr05">{{ data.merchant_slip_number }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="mb50">
          <div class="d-flex flex-wrap">
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">障害取消フラグ</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ data.disable_cancellation_flag }}</p>
              </div>
            </div>
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">カウンタ番号</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ data.counter_number }}</p>
              </div>
            </div>
          </div>
          <div class="d-flex flex-wrap">
            <div class="d-flex datacontainerFullWidth flex-nowrap">
              <div class="grey-background greyBorder container25 d-flex">
                <p class="ml05">送信元区分</p>
              </div>
              <div class="greyBorder container75 d-flex">
                <p class="mr05">{{ data.source_category }}</p>
              </div>
            </div>
          </div>
          <div class="d-flex flex-wrap">
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">残高更新結果</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ data.after_update_balance }}</p>
              </div>
            </div>
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">業務エラーコード</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ data.business_error_code }}</p>
              </div>
            </div>
          </div>
          <div class="d-flex flex-wrap">
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">POS Entry mode</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ data.pos_entry_mode }}</p>
              </div>
            </div>
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">承認削除区分</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ data.approval_deletion_category }}</p>
              </div>
            </div>
          </div>
          <div class="d-flex flex-wrap">
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">代行有無フラグ</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ data.daikou_flag }}</p>
              </div>
            </div>
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">国際ブランドリスクスコア情報</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">
                  {{ data.international_brand_risk_core_information }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="mb50">
          <div class="d-flex flex-wrap">
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">画面取消フラグ</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ data.screen_canceled_flag }}</p>
              </div>
            </div>
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">支払タイプ</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ data.payment_type }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="mb50">
          <div class="d-flex flex-wrap">
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">タイムスタンプ</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ data.timestamp }}</p>
              </div>
            </div>
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">トークン番号</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ data.token_number }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="show2" :key="key">
      <div v-if="loading">loading...</div>
      <div v-if="!loading" class="table-responsive">
        <h3>売上</h3>
        <div class="mb50">
          <div class="d-flex flex-wrap">
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">取引日</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ data.transaction_date }}</p>
              </div>
            </div>
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">フォーマット区分</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ data.format_category_text }}</p>
              </div>
            </div>
          </div>
          <div class="d-flex flex-wrap">
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">売上•入金区分</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ data.sales_payment_category }}</p>
              </div>
            </div>
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">摘要区分</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ data.summary_category_text }}</p>
              </div>
            </div>
          </div>
          <div class="d-flex flex-wrap">
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">通貨コード</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ data.currency_code }}</p>
              </div>
            </div>
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">カード種類</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ data.card_type }}</p>
              </div>
            </div>
          </div>
          <div class="d-flex flex-wrap">
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">決済買上/入出金金額</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ data.settlement_operation_amount }}</p>
              </div>
            </div>
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">決済ATM手数料</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ data.settlement_atm_fee_amount }}</p>
              </div>
            </div>
          </div>
        </div>
        <h3>取引詳細</h3>
        <div class="mb50">
          <div class="d-flex flex-wrap">
            <div class="d-flex datacontainerFullWidth flex-nowrap">
              <div class="grey-background greyBorder container25 d-flex">
                <p class="ml05">売上詳細ID</p>
              </div>
              <div class="greyBorder container75 d-flex">
                <p class="mr05">{{ data.sales_details_id }}</p>
              </div>
            </div>
          </div>
          <div class="d-flex flex-wrap">
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">取引特定情報</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ data.transaction_specific_information }}</p>
              </div>
            </div>
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">元取引特定情報</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">
                  {{ data.original_transaction_specific_information }}
                </p>
              </div>
            </div>
          </div>
          <div class="d-flex flex-wrap">
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">契約番号</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ data.contract_number }}</p>
              </div>
            </div>
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">取引日</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ data.transaction_details_date }}</p>
              </div>
            </div>
          </div>
          <div class="d-flex flex-wrap">
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">摘要区分</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ data.summary_details_category }}</p>
              </div>
            </div>
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">残高調整情報ID</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ data.balance_adjustment_information_id }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="mb50">
          <div class="d-flex flex-wrap">
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">カード種類</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ data.transaction_date }}</p>
              </div>
            </div>
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">買上日</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ data.purchase_date }}</p>
              </div>
            </div>
          </div>
          <div class="d-flex flex-wrap">
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">売上区分</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ data.sales_details_category }}</p>
              </div>
            </div>
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">トランザクションID</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ data.transaction_id }}</p>
              </div>
            </div>
          </div>
          <div class="d-flex flex-wrap">
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">国際ブランドデータID</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ data.international_brand_data_id }}</p>
              </div>
            </div>
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">オリジナル国際ブランドデータID</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">
                  {{ data.original_international_brand_data_id }}
                </p>
              </div>
            </div>
          </div>
          <div class="d-flex flex-wrap">
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">CPD</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ data.CPD }}</p>
              </div>
            </div>
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">承認番号</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">
                  {{ data.approval_number }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="mb50">
          <div class="d-flex flex-wrap">
            <div class="d-flex datacontainerFullWidth flex-nowrap">
              <div class="grey-background greyBorder container25 d-flex">
                <p class="ml05">基準通貨コード</p>
              </div>
              <div class="greyBorder container75 d-flex">
                <p class="mr05">{{ data.base_currency_code }}</p>
              </div>
            </div>
          </div>
          <div class="d-flex flex-wrap">
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">基準買上金額</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ data.base_purchase_amount }}</p>
              </div>
            </div>
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">基準現地手数料</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ data.base_local_fee }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="mb50">
          <div class="d-flex flex-wrap">
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">決済通貨コード</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ data.settlement_currency_code }}</p>
              </div>
            </div>
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">決済買上金額</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ data.settlement_purchase_amount }}</p>
              </div>
            </div>
          </div>
          <div class="d-flex flex-wrap">
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">決済ATM手数料</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ data.settlement_atm_fee_details }}</p>
              </div>
            </div>
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">決済海外取扱手数料</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ data.settlement_overseas_handling_fee }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="mb50">
          <div class="d-flex flex-wrap">
            <div class="d-flex datacontainerFullWidth flex-nowrap">
              <div class="grey-background greyBorder container25 d-flex">
                <p class="ml05">利用通貨コード</p>
              </div>
              <div class="greyBorder container75 d-flex">
                <p class="mr05">{{ data.used_currency_code }}</p>
              </div>
            </div>
          </div>
          <div class="d-flex flex-wrap">
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">利用買上金額</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ data.purchase_amount }}</p>
              </div>
            </div>
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">利用現地手数料</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ data.local_fee }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="mb50">
          <div class="d-flex flex-wrap">
            <div class="d-flex datacontainerFullWidth flex-nowrap">
              <div class="grey-background greyBorder container25 d-flex">
                <p class="ml05">決済通貨レート</p>
              </div>
              <div class="greyBorder container75 d-flex">
                <p class="mr05">{{ data.settlement_currency_rate }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="mb50">
          <div class="d-flex flex-wrap">
            <div class="d-flex datacontainerFullWidth flex-nowrap">
              <div class="grey-background greyBorder container25 d-flex">
                <p class="ml05">国コード</p>
              </div>
              <div class="greyBorder container75 d-flex">
                <p class="mr05">{{ data.country_code }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="mb50">
          <div class="d-flex flex-wrap">
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">加盟店業種コード</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ data.merchant_category_code }}</p>
              </div>
            </div>
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">加盟店契約業者コード</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ data.merchant_contractor_code }}</p>
              </div>
            </div>
          </div>
          <div class="d-flex flex-wrap">
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">加盟店ID</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ data.merchant_id }}</p>
              </div>
            </div>
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">加盟店端末ID</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ data.merchant_terminal_id }}</p>
              </div>
            </div>
          </div>
          <div class="d-flex flex-wrap">
            <div class="d-flex datacontainerFullWidth flex-nowrap">
              <div class="grey-background greyBorder container25 d-flex">
                <p class="ml05">加盟店名</p>
              </div>
              <div class="greyBorder container75 d-flex">
                <p class="mr05">{{ data.merchant_name }}</p>
              </div>
            </div>
          </div>
          <div class="d-flex flex-wrap">
            <div class="d-flex datacontainerFullWidth flex-nowrap">
              <div class="grey-background greyBorder container25 d-flex">
                <p class="ml05">ARN/ARD</p>
              </div>
              <div class="greyBorder container75 d-flex">
                <p class="mr05">{{ data.arn_ard }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="mb50">
          <div class="d-flex flex-wrap">
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">POS Entry Mode</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ data.pos_entry_mode }}</p>
              </div>
            </div>
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">チャージバック中フラグ</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ data.charge_back_flag }}</p>
              </div>
            </div>
          </div>
          <div class="d-flex flex-wrap">
            <div class="d-flex datacontainerFullWidth flex-nowrap">
              <div class="grey-background greyBorder container25 d-flex">
                <p class="ml05">Presentment</p>
              </div>
              <div class="greyBorder container75 d-flex">
                <p class="mr05">{{ data.presentment }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="mb50">
          <div class="d-flex flex-wrap">
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">画面取消フラグ</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ data.screen_canceled_flag }}</p>
              </div>
            </div>
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">保留解除日</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ data.release_date }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="mb50">
          <div class="d-flex flex-wrap">
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">タイムスタンプ</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ data.timestamp }}</p>
              </div>
            </div>
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">トークン番号</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ data.token_number }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="show3" :key="key">
      <div v-if="loading">loading...</div>
      <div v-if="!loading" class="table-responsive">
        <h3>入出金</h3>
        <div class="mb50">
          <div class="d-flex flex-wrap">
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">取引日</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ data.transaction_date }}</p>
              </div>
            </div>
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">フォーマット区分</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ data.format_category_text }}</p>
              </div>
            </div>
          </div>
          <div class="d-flex flex-wrap">
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">売上•入金区分</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ data.sales_payment_category }}</p>
              </div>
            </div>
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">摘要区分</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ data.summary_category_text }}</p>
              </div>
            </div>
          </div>
          <div class="d-flex flex-wrap">
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">通貨コード</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ data.currency_code }}</p>
              </div>
            </div>
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">カード種類</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ data.card_type }}</p>
              </div>
            </div>
          </div>
          <div class="d-flex flex-wrap">
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">決済買上/入出金金額</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ data.settlement_operation_amount }}</p>
              </div>
            </div>
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">決済ATM手数料</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ data.settlement_atm_fee_amount }}</p>
              </div>
            </div>
          </div>
        </div>
        <h3>取引詳細</h3>
        <div class="mb50">
          <div class="d-flex flex-wrap">
            <div class="d-flex datacontainerFullWidth flex-nowrap">
              <div class="grey-background greyBorder container25 d-flex">
                <p class="ml05">入金詳細ID</p>
              </div>
              <div class="greyBorder container75 d-flex">
                <p class="mr05">{{ data.deposit_details_id }}</p>
              </div>
            </div>
          </div>
          <div class="d-flex flex-wrap">
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">取引特定情報</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ data.transaction_specific_information }}</p>
              </div>
            </div>
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">元取引特定情報</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">
                  {{ data.original_transaction_specific_information }}
                </p>
              </div>
            </div>
          </div>
          <div class="d-flex flex-wrap">
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">契約番号</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ data.contract_number }}</p>
              </div>
            </div>
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">取引日</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ data.transaction_details_date }}</p>
              </div>
            </div>
          </div>
          <div class="d-flex flex-wrap">
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">摘要区分</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ data.summary_details_category }}</p>
              </div>
            </div>
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">残高調整情報ID</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ data.balance_adjustment_information_id }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="mb50">
          <div class="d-flex flex-wrap">
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">入金日</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ data.deposit_date }}</p>
              </div>
            </div>
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">入金識別</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ data.deposit_identification }}</p>
              </div>
            </div>
          </div>
          <div class="d-flex flex-wrap">
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">入金区分</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ data.deposit_category }}</p>
              </div>
            </div>
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">入金取引区分</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ data.deposit_transaction_category }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="mb50">
          <div class="d-flex flex-wrap">
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">入金通貨コード</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ data.deposit_currency_code }}</p>
              </div>
            </div>
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">入金額</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ data.deposit_amount }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="mb50">
          <div class="d-flex flex-wrap">
            <div class="d-flex datacontainerFullWidth flex-nowrap">
              <div class="grey-background greyBorder container25 d-flex">
                <p class="ml05">更新前残高</p>
              </div>
              <div class="greyBorder container75 d-flex">
                <p class="mr05">{{ data.before_update_balance }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="mb50">
          <div class="d-flex flex-wrap">
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">残高更新結果</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ data.after_update_balance }}</p>
              </div>
            </div>
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">業務エラーコード</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ data.business_error_code }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="mb50">
          <div class="d-flex flex-wrap">
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">画面取消フラグ</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ data.screen_canceled_flag }}</p>
              </div>
            </div>
            <div class="d-flex datacontainer flex-nowrap">
              <div class="grey-background greyBorder container50 d-flex">
                <p class="ml05">タイムスタンプ</p>
              </div>
              <div class="greyBorder container50 d-flex">
                <p class="mr05">{{ data.timestamp }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="mb50">
          <div class="d-flex flex-wrap">
            <div class="d-flex datacontainerFullWidth flex-nowrap">
              <div class="grey-background greyBorder container25 d-flex">
                <p class="ml05">摘要文言</p>
              </div>
              <div class="greyBorder container75 d-flex">
                <p class="mr05">{{ data.summary }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import master from "@/constants/MasterEnum";
import sex from "@/constants/SexEnum";
import countries from "@/constants/CountriesEnum";
import prefs from "@/constants/PrefsEnum";
import utils from "@/utils/Utils";
import firebase from "firebase";

export default {
  name: "TransactionDetails",
  mixins: [utils, master, sex, countries, prefs],
  data() {
    return {
      transactionId: "",
      show: false,
      show2: false,
      show3: false,
      loading: true,
      data: [],
      db: firebase.firestore(),
    };
  },
  created: function() {
    this.transactionId = this.$route.query.transactionId.toString();
    this.loadData();
  },
  methods: {
    init() {
      this.show = false;
      this.show2 = false;
      this.show3 = false;
      this.key = this.key ? 0 : 1;
    },
    async loadData() {
      this.init();
      const doc = await this.db
        .collection("transactions")
        .doc(this.transactionId)
        .get();
      if (doc.exists) {
        this.data = doc.data();
        this.transformDataToText(this.data);
        switch (this.data.format_category) {
          case "01":
            this.show = true;
            break;
          case "02":
            this.show2 = true;
            break;
          case "03":
            this.data.summary = this.data.summary.trim();
            this.show3 = true;
            break;
          default:
            break;
        }
      }
      this.loading = false;
    },

    transformDataToText(data) {
      if (data.format_category == "03") {
        // 入金
        let sales_payment_categoryText = this.depositCategories[
          data.sales_payment_category
        ];
        if (sales_payment_categoryText !== undefined) {
          data.sales_payment_category = sales_payment_categoryText;
        }
      } else {
        //売上
        let sales_payment_categoryText = this.salesCategories[
          data.sales_payment_category
        ];
        if (sales_payment_categoryText !== undefined) {
          data.sales_payment_category = sales_payment_categoryText;
        }
      }

      let cardTypeText = this.card_type_codes[data.card_type];
      if (cardTypeText !== undefined) {
        data.card_type = cardTypeText;
      }

      let salesText = this.salesCategories[data.sales_details_category];
      if (salesText !== undefined) {
        data.sales_details_category = salesText;
      }

      let summaryDetailsText = this.summaryCategories[
        data.summary_details_category
      ];
      if (summaryDetailsText !== undefined) {
        data.summary_details_category = summaryDetailsText;
      }

      let businessText = this.businessCategories[data.business_category_code];
      if (businessText !== undefined) {
        data.business_category_code = businessText;
      }

      let sourceText = this.sourcesCategories[data.source_category];
      if (sourceText !== undefined) {
        data.source_category = sourceText;
      }

      let deletionText = this.approvalDeletionCategories[
        data.approval_deletion_category
      ];
      if (deletionText !== undefined) {
        data.approval_deletion_category = deletionText;
      }

      let screenCancellationText = this.screenCancelationCategories[
        data.screen_canceled_flag
      ];
      if (screenCancellationText !== undefined) {
        data.screen_canceled_flag = screenCancellationText;
      }

      let paymentText = this.paymentTransactionsCategories[data.payment_type];
      if (paymentText !== undefined) {
        data.payment_type = paymentText;
      }

      let depositIdentificationText = this.depositIdentificationCategories[
        data.deposit_identification
      ];
      if (depositIdentificationText !== undefined) {
        data.deposit_identification = depositIdentificationText;
      }

      let depositCategoryText = this.depositCategories[data.deposit_category];
      if (depositCategoryText !== undefined) {
        data.deposit_category = depositCategoryText;
      }

      let depositTransactionText = this.depositTransactionCategory[
        data.deposit_transaction_category
      ];
      if (depositTransactionText !== undefined) {
        data.deposit_transaction_category = depositTransactionText;
      }

      let formatCategoryText = this.formatCategories[data.format_category];
      if (formatCategoryText !== undefined) {
        data.format_category_text = formatCategoryText;
      }
      let summaryCategoryText = this.summaryCategories[data.summary_category];
      if (summaryCategoryText !== undefined) {
        data.summary_category_text = summaryCategoryText;
      }

      data.base_purchase_amount = this.setTextWithCode(
        data.base_purchase_amount_code,
        data.base_purchase_amount,
        true
      );
      data.settlement_operation_amount = this.setTextWithCode(
        data.settlement_operation_code,
        data.settlement_operation_amount,
        true
      );
      data.settlement_atm_fee_amount = this.setTextWithCode(
        data.settlement_atm_fee_code,
        data.settlement_atm_fee_amount,
        true
      );
      data.deposit_amount = this.setTextWithCode(
        data.deposit_amount_code,
        data.deposit_amount,
        true
      );

      data.before_update_balance = this.setTextWithCode(
        data.before_update_balance_code,
        data.before_update_balance,
        true
      );
      data.settlement_atm_fee_details = this.setTextWithCode(
        data.settlement_atm_fee_details_code,
        data.settlement_atm_fee_details,
        true
      );

      data.base_local_fee = this.setTextWithCode(
        data.base_local_fee_code,
        data.base_local_fee,
        true
      );

      data.settlement_purchase_amount = this.setTextWithCode(
        data.settlement_purchase_amount_code,
        data.settlement_purchase_amount,
        true
      );

      data.settlement_overseas_handling_fee = this.setTextWithCode(
        data.settlement_overseas_handling_fee_code,
        data.settlement_overseas_handling_fee,
        true
      );
      data.purchase_amount = this.setTextWithCode(
        data.purchase_amount_code,
        data.purchase_amount,
        true
      );
      data.local_fee = this.setTextWithCode(
        data.local_fee_code,
        data.local_fee,
        true
      );
    },
  },
};
</script>
